// extracted by mini-css-extract-plugin
export default {"addBtn":"AddButton_addBtn__e7guo","addBtnText":"AddButton_addBtnText__RxhVS"};